import {EPaymentInstrument} from "../utils/hooks/digital-wallets/wallet-types";

export const PROVIDER_NAMES = {
  [EPaymentInstrument.GooglePay]: {
    full: "Google Pay",
    short: "G Pay"
  },
  [EPaymentInstrument.ApplePay]: {
    full: "Apple Pay",
    short: "Apple Pay"
  },
};
